import React from 'react';
 import './TableHeader.scss';
import SouthIcon from '@mui/icons-material/South';
import NorthIcon from '@mui/icons-material/North';

 type Props = {
   headerColumns: any[];
   gap?: string;
   onSort?: (key: string, direction: 'asc' | 'desc') => void;
 };

const TableHeader: React.FC<Props> = ({ headerColumns, gap, onSort }) => {
  const [sortKey, setSortKey] = React.useState<string | null>(null);
  const [sortOrder, setSortOrder] = React.useState<'asc' | 'desc'>('asc');

  const handleSort = (key: string, columnKey: string) => {
    if (!onSort) return;
    
    let newOrder: 'asc' | 'desc' = 'asc';
    if (sortKey === columnKey && sortOrder === 'asc') {
      newOrder = 'desc';
    }

    setSortKey(columnKey);
    setSortOrder(newOrder);

    onSort(key, newOrder);
  };

   return (
     <div className='table-header-container' style={{ gap }}>
       {headerColumns.map((column, index) => {
        const isSorted = sortKey === column.key;
        const isSortable = column.sortable && onSort;

         return (
           <div
             key={index}
             className='table-header-column'
            style={{
              minWidth: column.minWidth,
              width: column.width || column.minWidth,
              maxWidth: column.width || column.minWidth,
              flex:
                column.flex === 0
                  ? `0 0 ${column.width || column.minWidth || 'auto'}`
                  : `1 0 ${column.minWidth || 'auto'}`,
              flexShrink: 0,
              cursor: isSortable ? 'pointer' : 'default',
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              paddingLeft: column.headerPaddingLeft || 0,
              paddingRight: column.headerPaddingRight || 0,
              boxSizing: 'border-box',
            }}
            onClick={() => isSortable && handleSort(column.apiKey, column.key)}
           >
             {column.title}
            {isSortable && (
              <div className='sort-icons'>
                <NorthIcon className={`sort-icon ${isSorted && sortOrder === 'asc' ? 'active' : ''}`}/> 
                <SouthIcon className={`sort-icon ${isSorted && sortOrder === 'desc' ? 'active' : ''}`}/>
              </div>
            )}
           </div>
         );
       })}
       </div>
   );
 };

 export default TableHeader;